import { RackTypeEnum } from "@gtpl/shared-models/common-models";
import {BaseEntity,Column,Entity,Index,JoinColumn,JoinTable,ManyToMany,ManyToOne,OneToMany,OneToOne,PrimaryColumn,PrimaryGeneratedColumn,RelationId, VersionColumn, UpdateDateColumn, CreateDateColumn} from "typeorm";
import { Locations } from "../locations/location.entity";
import { RackPosition } from "../rack-position/rack-position.entity";
import { RackZoneMapping } from "../rack-zone-mapping/rack-zone-mapping-entity";
import { ZoneMaster } from "../zone-master/zone-master.entity";

@Entity('rack')
export class Rack {
  @PrimaryGeneratedColumn('increment', { name: 'rack_id' })
  rackId: number;


  @Column("varchar",{
    nullable:false,
    length:20,
    name:"rack_code"
  })
  rackCode:string;

  @Column('varchar', {
    nullable: false,
    length: 30,
    name: 'rack_name',
  })
  rackName: string;  

 

  @Column("int", {
    nullable: true,
    name: "zone_id"
  })
  zoneId: number;

  @Column("int", {
    nullable: true,
    name: "allocated_zone_id"
  })
  allocatedZoneId: number;
  
  @Column('boolean', {
    nullable: false,
    default: true,
    name: 'is_active',
  })
  isActive: boolean;
  @Column('int', {
    nullable: true,
    default: 0,
    name: 'reserved_for_dummy',
  })
  reservedForDummy: number;

  @Column({
    type: 'enum',
    enum: RackTypeEnum,
    nullable: false,
    default: RackTypeEnum.Center,
    name: 'rack_type'
  })
  rackPosition: RackTypeEnum;

  @Column('int', {
    nullable: true,
    default: 0,
    name: 'rack_status',
  })
  rackStatus: number;

  @CreateDateColumn({
    name: 'created_at',
    type: 'datetime',
  })
  createdAt: Date;

  @Column('varchar', {
    nullable: false,
    name: 'created_user',
    length: 50,
  })
  createdUser: string | null;

  @UpdateDateColumn({
    name: 'updated_at',
    type: 'datetime',
  })
  updatedAt: Date;

  @Column('varchar', {
    nullable: true,
    name: 'updated_user',
    length: 50,
  })
  updatedUser: string | null;

  @VersionColumn({
    default: 1,
    name: 'version_flag',
  })
  versionFlag: number;
  
  @ManyToOne(type => ZoneMaster, zoneMaster => zoneMaster.racksInfo, { nullable: false, })
  @JoinColumn({ name: "zone_id" })
  zoneMasterInfo: ZoneMaster;

  @OneToMany((type) => RackZoneMapping, (rack) => rack.rackInfo)
  rackZoneInfo: RackZoneMapping[];

  @OneToMany(type => Locations, loc => loc.rackInfo)
  locationsInfo: Locations[];

  @OneToMany(type => RackPosition, rcp => rcp.rackMasterInfo)
  rackPositionInfo: RackPosition[];

  @Column('integer', {
    nullable: true,
    name: 'plant_id'
  })
  plantId: number;

  @Column('integer', {
    nullable: true,
    name: 'allocated_plant_id'
  })
  allocatedPlantId: number;

}
